import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useData } from "@/context/DataContext";

const PRESETS = [5, 10, 15, 30];

export const HorizonSelector = () => {
  const { data, horizon, setHorizon } = useData();
  const years = data?.model?.years || [];
  const n = years.length;
  const span = horizon.to - horizon.from + 1;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="year-horizon-selector">
      <div className="flex rounded-full border border-slate-700 bg-slate-900/70 p-0.5">
        {PRESETS.filter((p) => p <= Math.max(n, 5)).map((p) => (
          <button
            key={p}
            data-testid={`horizon-preset-${p}y`}
            onClick={() => setHorizon({ from: 0, to: Math.min(p, n) - 1 })}
            className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
              horizon.from === 0 && span === Math.min(p, n) ? "bg-amber-500 text-slate-950" : "text-slate-400 hover:text-slate-100"
            }`}
          >
            {p}Y
          </button>
        ))}
      </div>
      <YearSelect testid="horizon-from-select" value={horizon.from} years={years}
        onChange={(v) => setHorizon((h) => ({ from: v, to: Math.max(v, h.to) }))} />
      <span className="text-xs text-slate-500">to</span>
      <YearSelect testid="horizon-to-select" value={horizon.to} years={years}
        onChange={(v) => setHorizon((h) => ({ from: Math.min(v, h.from), to: v }))} />
    </div>
  );
};

const YearSelect = ({ value, years, onChange, testid }) => (
  <Select value={String(value)} onValueChange={(v) => onChange(Number(v))}>
    <SelectTrigger data-testid={testid} className="h-8 w-[104px] rounded-full border-slate-700 bg-slate-900/70 text-xs num">
      <SelectValue />
    </SelectTrigger>
    <SelectContent className="max-h-72 bg-[#131c2e]">
      {years.map((y, i) => (
        <SelectItem key={y} value={String(i)} className="num text-xs">FY {y}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
